import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export interface ButtonContainerProps {
  size?: string;
  sizeLg?: string;
  sizeSubLg?: string;
  sizeMd?: string;
  sizeSm?: string;
  sizeXs?: string;
  textColor?: string;
  backgroundColor?: string;
  customBorderRadius?: number;
  customFontWeight?: number;
  customBorderColor?: string;
}

export const ButtonPrimaryContainer = styled.button<ButtonContainerProps>`
  outline: none;
  cursor: pointer;
  background-color: ${({ color }) => color ?? palette.standardYellow};
  color: ${({ textColor }) => textColor ?? palette.greyText};
  font-size: ${(props) => props.size ?? '1rem'};
  border: none;
  width: auto;
  padding: 13px 18px;
  font-weight: ${({ customFontWeight }) => customFontWeight ?? 700};
  align-self: center;
  text-align: center;
  position: relative;
  justify-self: stretch;
  font-family: 'Mulish', sans-serif;
  box-sizing: border-box;
  transition: all 0.3s ease-in-out;
  line-height: 20px;
  border-radius: ${(props) => props.customBorderRadius ?? 32}px;
  border: 1px solid ${({ customBorderColor, textColor }) => customBorderColor ?? textColor ?? 'white'};

  &:hover {
    -webkit-filter: brightness(85%);
    filter: brightness(85%);
  }

  .icon-right {
    margin-left: 0.5rem;
  }

  .icon-left {
    margin-right: 0.5rem;
  }

  ${({ sizeLg }) =>
    !sizeLg
      ? ''
      : `
    @media all and (max-width: ${layout.lg}) {
        font-size: ${sizeLg}};
        line-height: calc(${sizeLg} + 4px);
    }`}
  ${({ sizeSubLg }) =>
    !sizeSubLg
      ? ''
      : `
    @media all and (max-width: ${layout.subLg}) {
        font-size: ${sizeSubLg}};
        line-height: calc(${sizeSubLg} + 4px);
    }`}
  ${({ sizeMd }) =>
    !sizeMd
      ? ''
      : `
    @media all and (max-width: ${layout.md}) {
        font-size: ${sizeMd};
        line-height: calc(${sizeMd} + 4px);
    }`}
  ${({ sizeSm }) =>
    !sizeSm
      ? ''
      : `
    @media all and (max-width: ${layout.sm}) {
        font-size: ${sizeSm};
        line-height: calc(${sizeSm} + 4px);
    }`}
  ${({ sizeXs }) =>
    !sizeXs
      ? ''
      : `
    @media all and (max-width: ${layout.xs}) {
        font-size: ${sizeXs};
        line-height: calc(${sizeXs} + 4px);
    }`}
`;
